import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyRoleBasedNotifications: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-role-based-notifications", jiraSpaEntry: "async-jira-eoc-role-based-notifications" */ '@jira/eoc__role-based-notifications/src/index.tsx'
	).then((module) => module.RoleBasedNotificationsPage),
);

export const RoleBasedNotificationsComponent = (): React.JSX.Element => (
	<LazyPage
		Page={LazyRoleBasedNotifications}
		pageId="async-jira-eoc-role-based-notifications"
		shouldShowSpinner={false}
	/>
);
